var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.177c0-.4.321-.726.728-.726h12.09c.402 0 .728.322.728.726v.726H0v-.726z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M3.565 1.451C3.565.65 4.204 0 4.989 0h3.568c.787 0 1.424.651 1.424 1.451v1.452H3.565V1.45zM12.736 3.628l-.9 13.43c-.04.599-.55 1.084-1.14 1.084H2.493c-.59 0-1.089-.486-1.116-1.084l-.6-13.43h11.96zM9.892 5.806H9.18l-.623 10.16h.713l.623-10.16zm-5.525 0h-.713l.624 10.16h.713l-.624-10.16zm2.763 0h-.713v10.16h.713V5.805z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ff7a392ff5a18209dd49cb31404b1482.svg";
export { ForwardRef as ReactComponent };